import Header from 'components/header';
import { SideBar } from 'components/header/side-bar';
import SpinnerBackdrop from 'components/spinner-backdrop';
import { ENV_VARS } from 'constants/environment.constants';
import { withAuthorization } from 'hoc';
import 'kfone-component-library/style.css';
import { KF1AppRootProvider, kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import type { FC } from 'react';
import { useState } from 'react';

// import { InitilaizeDatadog } from 'services/datadog.service';
import { ODSToastNotificationContainer } from 'kfone-component-library';
import 'kfone-component-library/font-faces.css';
import GlobalRouter from './router';
import { ILanguageProviderProps } from 'kfone-frontend-core/interfaces';
import { TRANSLATION_ID } from 'model/constants/shared';
import appLanguageResources from 'shared/locales';

if (ENV_VARS.API_URL.split('.')[1].split('-')[1] === 'dev') {
  // InitilaizeDatadog();
}

const App: FC = () => {
  const [languageProps, setLanguageProps] = useState<ILanguageProviderProps>({
    resources: appLanguageResources,
    translationId: TRANSLATION_ID,
  });

  // Execute blow code sinppet only for local developement to update the authToken for API
  if (window.location.hostname === 'localhost' && window.location.port === '3086') {
    kf1AuthenticatedHttpClient.interceptors.request.use((config) => {
      const authToken = sessionStorage.getItem('authToken');
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      return config;
    });
  }

  const [show, setShow] = useState(false);
  // useEffect(() => {
  //   InitilaizeDatadog();
  // }, []);
  return (
    <KF1AppRootProvider languageProps={languageProps}>
      <div>
        <Header name={''} setShow={(value: boolean) => setShow(value)} />
        <SideBar show={show} toggle={() => setShow(!show)} />
        <div className='relative top-[48px] ml-[64px]'>
          <GlobalRouter />
        </div>
        <SpinnerBackdrop />
        <ODSToastNotificationContainer />
      </div>
    </KF1AppRootProvider>
  );
};

const AppComponentWithAuthorization = withAuthorization(App);
AppComponentWithAuthorization.displayName = 'AppComponentWithAuthorization';

export default AppComponentWithAuthorization;
